;(function () {
  if (window.__EasterEggHuntLoaded) return
  window.__EasterEggHuntLoaded = true

  class EasterEggHunt {
    constructor() {
      this.eggs = document.querySelectorAll("[data-easter-egg]")

      const config = window.__EasterHuntConfig || {}
      // The theme setting is the source of truth for the total; DOM counting is
      // only a fallback because banner/slot counts vary per page.
      const domTotal =
        document.querySelectorAll("[data-egg-slot]").length ||
        document.querySelectorAll(".easter-egg-banner.easter-egg-banner--bg-grey").length
      this.totalEggs = parseInt(config.totalEggs, 10) || domTotal || 10
      // Blank threshold settings spread the three tiers evenly across the total (1/3, 2/3, all)
      this.tiers = [
        parseInt(config.tier1Eggs, 10) || Math.round(this.totalEggs / 3),
        parseInt(config.tier2Eggs, 10) || Math.round((this.totalEggs * 2) / 3),
        parseInt(config.tier3Eggs, 10) || this.totalEggs,
      ]
      this.titles = {
        first: config.popupTitleFirst || "Your first egg!",
        progress: config.popupTitleProgress || "Egg {count} of {total}",
        notFound: config.popupTitleNotFound || "Not found yet",
        unlocked: config.popupTitleUnlocked || "{reward} unlocked",
        creditClaimed: config.popupTitleCreditClaimed || "Store credit claimed!",
      }

      this.popup = document.querySelector("[data-easter-popup]") || this.createPopup()
      this.counter = document.querySelector("[data-egg-counter]")
      this.countDisplay = document.querySelector("[data-egg-count-display]")

      const eggEl = this.eggs.length ? this.eggs[0] : null
      const fromCounter = this.counter ? parseInt(this.counter.textContent, 10) : null
      const fromEgg = eggEl ? parseInt(eggEl.getAttribute("data-collected-count") || "0", 10) : 0
      this.collectedCount = fromCounter !== null ? fromCounter : fromEgg
      this.appProxyUrl = "/apps/easter-hunt/collect"
      this.claimUrl = "/apps/easter-hunt/collect"

      this.rewards = this.getRewardsFromDOM()

      this.init()
    }

    getRewardsFromDOM() {
      const config = window.__EasterHuntConfig || {}
      const tier1Title = config.tier1Title || "Discount Code up to 50% Off"
      const tier2Title = config.tier2Title || "Peelerz Gummy Eggs"
      const tier3Title = config.tier3Title || "Up to £100 Store Credit"
      const tier2VariantId = config.tier2VariantId || null

      const defaults = {}
      defaults[this.tiers[0]] = { title: tier1Title, type: "discount", desc: "", cta: "Copy discount code", popupTitle: "Discount Code" }
      defaults[this.tiers[1]] = { title: tier2Title, type: "product", desc: "", cta: "Add to cart", variantId: tier2VariantId }
      defaults[this.tiers[2]] = { title: tier3Title, type: "credit", desc: "", cta: "Claim store credit" }

      document.querySelectorAll("[data-reward-tier]").forEach((card) => {
        const tier = parseInt(card.getAttribute("data-reward-tier"), 10)
        if (defaults[tier]) {
          defaults[tier].desc = card.getAttribute("data-reward-desc") || defaults[tier].desc
          defaults[tier].cta = card.getAttribute("data-reward-cta") || defaults[tier].cta
          if (card.getAttribute("data-reward-variant")) {
            defaults[tier].variantId = card.getAttribute("data-reward-variant")
          }
          if (card.getAttribute("data-discount-code")) {
            defaults[tier].discountCode = card.getAttribute("data-discount-code")
          }
        }
      })

      return defaults
    }

    formatTitle(template, data) {
      data = data || {}
      return template
        .replace("{count}", data.count !== undefined ? data.count : "")
        .replace("{total}", this.totalEggs)
        .replace("{reward}", data.reward || "")
    }

    createPopup() {
      const popup = document.createElement("div")
      popup.className = "easter-hunt--popup"
      popup.setAttribute("data-easter-popup", "")
      popup.style.display = "none"
      popup.innerHTML = `
        <div class="easter-hunt--popup-overlay" data-easter-popup-close></div>
        <div class="easter-hunt--popup-content">
          <button class="easter-hunt--popup-close" data-easter-popup-close aria-label="Close popup">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
          <div class="easter-hunt--popup-icon" data-popup-icon>
            <svg viewBox="0 0 80 112" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M40 4C20 4 4 36 4 64C4 90 20 108 40 108C60 108 76 90 76 64C76 36 60 4 40 4Z" fill="#FFD700" stroke="#DAA520" stroke-width="2"/>
            </svg>
          </div>
          <span class="easter-hunt--popup-badge" data-popup-badge></span>
          <h2 class="easter-hunt--popup-title" data-popup-title></h2>
          <p class="easter-hunt--popup-text" data-popup-text></p>
          <div class="easter-hunt--popup-progress" data-popup-progress>
            <div class="easter-hunt--popup-progress-header">
              <span class="easter-hunt--popup-progress-count" data-popup-progress-count>0 / ${this.totalEggs}</span>
              <span class="easter-hunt--popup-progress-pct" data-popup-progress-pct>0% complete</span>
            </div>
            <div class="easter-hunt--popup-progress-bar">
              <div class="easter-hunt--popup-progress-fill" data-popup-progress-fill style="width: 0%"></div>
            </div>
          </div>
          <div class="easter-hunt--popup-next" data-popup-next>
            <span class="easter-hunt--popup-next-label">NEXT PRIZE</span>
            <div class="easter-hunt--popup-next-row">
              <svg class="easter-hunt--popup-next-icon" viewBox="0 0 48 48" fill="none" width="28" height="28"><rect x="8" y="20" width="32" height="22" rx="3" stroke="currentColor" stroke-width="2.5"/><path d="M24 8v12M16 20s0-8 8-8 8 8 8 8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/><line x1="24" y1="20" x2="24" y2="42" stroke="currentColor" stroke-width="2.5"/></svg>
              <div>
                <strong data-popup-next-title></strong>
                <span data-popup-next-eggs></span>
              </div>
            </div>
          </div>
          <div class="easter-hunt--popup-reward" data-popup-reward style="display:none;">
            <div class="easter-hunt--popup-reward-row">
              <svg class="easter-hunt--popup-reward-icon" viewBox="0 0 48 48" fill="none" width="28" height="28"><rect x="8" y="20" width="32" height="22" rx="3" stroke="currentColor" stroke-width="2.5"/><path d="M24 8v12M16 20s0-8 8-8 8 8 8 8" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/><line x1="24" y1="20" x2="24" y2="42" stroke="currentColor" stroke-width="2.5"/></svg>
              <div>
                <strong data-popup-reward-title></strong>
                <span data-popup-reward-desc></span>
              </div>
            </div>
            <p class="easter-hunt--popup-reward-next" data-popup-reward-next></p>
          </div>
          <button type="button" class="button button--blue-fill easter-hunt--popup-cta" data-popup-cta>Keep hunting</button>
        </div>
      `
      document.body.appendChild(popup)
      return popup
    }

    async isVariantInCart(variantId) {
      try {
        const res = await fetch("/cart.js")
        const cart = await res.json()
        return cart.items.some((item) => String(item.variant_id) === String(variantId))
      } catch (e) {
        return false
      }
    }

    eggCountToTierNum(count) {
      for (let i = this.tiers.length - 1; i >= 0; i--) {
        if (count >= this.tiers[i]) return i + 1
      }
      return 0
    }

    init() {
      this.bindEggClicks()
      this.bindEggSlotClicks()
      this.bindPopupClose()
      this.bindRewardClicks()
      this.bindCopyDiscount()
      this.bindAddToCart()
    }

    bindAddToCart() {
      document.querySelectorAll(".easter-hunt--reward-action [data-add-variant]").forEach((btn) => {
        if (btn.getAttribute("data-listener") === "true") return
        btn.setAttribute("data-listener", "true")
        btn.addEventListener("click", async () => {
          const variantId = btn.getAttribute("data-add-variant")
          if (!variantId) return

          const inCart = await this.isVariantInCart(variantId)
          if (inCart) {
            btn.textContent = "Already added"
            btn.className = "button button--sold-out"
            btn.style.pointerEvents = "none"
            return
          }

          btn.textContent = "Adding..."
          btn.style.pointerEvents = "none"
          try {
            await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
            })
            btn.textContent = "Already added"
            btn.className = "button button--sold-out"
            btn.removeAttribute("data-add-variant")
          } catch (err) {
            btn.textContent = "Add to cart"
            btn.style.pointerEvents = ""
          }
        })
      })
    }

    bindCopyDiscount() {
      document.querySelectorAll("[data-copy-discount]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const code = btn.getAttribute("data-copy-discount")
          navigator.clipboard.writeText(code).then(() => {
            const original = btn.textContent
            btn.textContent = "Copied!"
            setTimeout(() => {
              btn.textContent = original
            }, 2000)
          })
        })
      })
    }

    bindRewardClicks() {
      document.querySelectorAll("[data-reward]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const tier = parseInt(btn.getAttribute("data-reward"), 10)
          const reward = this.rewards[tier]
          if (!reward) return
          this.showTierPopup(tier, reward)
        })
      })
    }

    async showTierPopup(tier, reward) {
      if (!this.popup) return

      const icon = this.popup.querySelector("[data-popup-icon]")
      if (icon) {
        const card = document.querySelector(`[data-reward-tier="${tier}"]`)
        const img = card ? card.querySelector(".easter-hunt--reward-icon img") : null
        if (img) {
          icon.innerHTML = `<img src="${img.src}" alt="${reward.title}" style="width:100%;height:auto;object-fit:contain;">`
        }
      }

      const badge = this.popup.querySelector("[data-popup-badge]")
      const title = this.popup.querySelector("[data-popup-title]")
      const text = this.popup.querySelector("[data-popup-text]")
      const progressSection = this.popup.querySelector("[data-popup-progress]")
      const nextSection = this.popup.querySelector("[data-popup-next]")
      const rewardSection = this.popup.querySelector("[data-popup-reward]")
      const rewardTitle = this.popup.querySelector("[data-popup-reward-title]")
      const rewardDesc = this.popup.querySelector("[data-popup-reward-desc]")
      const rewardNext = this.popup.querySelector("[data-popup-reward-next]")
      const cta = this.popup.querySelector("[data-popup-cta]")

      if (badge) {
        badge.textContent = "TIER UNLOCKED"
        badge.classList.add("easter-hunt--popup-badge--reward")
      }
      if (title) title.textContent = this.formatTitle(this.titles.unlocked, { reward: reward.popupTitle || reward.title })
      if (text)
        text.textContent = reward.desc
          ? `You've found ${tier} eggs — ${reward.desc.charAt(0).toLowerCase() + reward.desc.slice(1)}`
          : `You've found ${tier} eggs — you've unlocked a ${reward.title.toLowerCase()}.`
      if (progressSection) progressSection.style.display = "none"
      if (nextSection) nextSection.style.display = "none"
      if (rewardSection) {
        rewardSection.style.display = ""
        if (rewardTitle) rewardTitle.textContent = reward.title
        if (rewardDesc)
          rewardDesc.textContent = reward.desc || "Choose any product from our full range"
        if (rewardNext) rewardNext.style.display = "none"
      }
      if (cta) {
        const card = document.querySelector(`[data-reward-tier="${tier}"]`)
        const isClaimed = card && card.classList.contains("claimed")
        const tierNum = this.eggCountToTierNum(tier)
        const variantId = reward.variantId || (card ? card.getAttribute("data-reward-variant") : null)
        const discountCode = card ? card.getAttribute("data-discount-code") : null
        cta.removeAttribute("data-add-variant")
        cta.removeAttribute("data-claim-tier")
        cta.removeAttribute("data-copy-discount")

        if (discountCode) {
          if (text) text.textContent = `Your discount code is:`
          if (rewardSection) {
            rewardSection.style.display = ""
            rewardSection.innerHTML = `
              <div class="easter-hunt--discount-code">
                <span class="easter-hunt--discount-code-value">${discountCode}</span>
              </div>`
          }
          cta.textContent = "Copy discount code"
          cta.className = "button button--blue-fill easter-hunt--popup-cta"
          cta.style.pointerEvents = ""
          cta.setAttribute("data-copy-discount", discountCode)
        } else if (variantId) {
          const inCart = await this.isVariantInCart(variantId)
          if (inCart) {
            cta.textContent = "Already added"
            cta.className = "button button--sold-out easter-hunt--popup-cta"
            cta.style.pointerEvents = "none"
          } else {
            cta.textContent = "Add to cart"
            cta.className = "button button--blue-fill easter-hunt--popup-cta"
            cta.style.pointerEvents = ""
            cta.setAttribute("data-add-variant", variantId)
          }
        } else if (isClaimed) {
          cta.textContent = "Claimed"
          cta.className = "button button--sold-out easter-hunt--popup-cta"
          cta.style.pointerEvents = "none"
        } else {
          cta.textContent = reward.cta || "Claim reward"
          cta.className = "button button--blue-fill easter-hunt--popup-cta"
          cta.style.pointerEvents = ""
          cta.setAttribute("data-claim-tier", String(tierNum))
        }
      }

      this.popup.style.display = "flex"
      requestAnimationFrame(() => {
        this.popup.classList.add("active")
        document.body.classList.add("no-scroll")
      })
    }

    showLoginPopup() {
      let loginPopup = document.querySelector("[data-easter-login-popup]")

      if (!loginPopup) {
        loginPopup = document.createElement("div")
        loginPopup.className = "easter-hunt--login-popup"
        loginPopup.setAttribute("data-easter-login-popup", "")
        loginPopup.innerHTML = `
          <div class="easter-hunt--login-popup-overlay"></div>
          <div class="easter-hunt--login-popup-content">
            <button class="easter-hunt--login-popup-close" data-login-popup-close aria-label="Close">&times;</button>
            <h2 class="easter-hunt--login-popup-title">You found an egg!</h2>
            <p class="easter-hunt--login-popup-text">Log in or create an account to start collecting eggs and unlock rewards.</p>
            <div class="easter-hunt--login-popup-actions">
              <a href="/account/login" class="button button--blue-fill">Log in</a>
              <a href="/account/register" class="button button--blue-border">Create account</a>
            </div>
          </div>
        `
        document.body.appendChild(loginPopup)

        loginPopup.querySelector("[data-login-popup-close]").addEventListener("click", () => {
          loginPopup.classList.remove("active")
          document.body.classList.remove("no-scroll")
          setTimeout(() => {
            loginPopup.style.display = "none"
          }, 300)
        })

        loginPopup
          .querySelector(".easter-hunt--login-popup-overlay")
          .addEventListener("click", () => {
            loginPopup.querySelector("[data-login-popup-close]").click()
          })
      }

      loginPopup.style.display = "flex"
      requestAnimationFrame(() => {
        loginPopup.classList.add("active")
        document.body.classList.add("no-scroll")
      })
    }

    bindEggClicks() {
      this.eggs.forEach((egg) => {
        if (egg.getAttribute("data-listener") === "true") return
        egg.setAttribute("data-listener", "true")

        egg.addEventListener("click", (e) => this.collectEgg(e, egg))
        egg.addEventListener("keydown", (e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault()
            this.collectEgg(e, egg)
          }
        })
      })
    }

    bindEggSlotClicks() {
      const slots = document.querySelectorAll("[data-egg-slot]")
      slots.forEach((slot) => {
        slot.style.cursor = "pointer"
        slot.addEventListener("click", () => {
          const isCollected = slot.classList.contains("collected")
          const eggNum = Array.from(slot.parentElement.children).indexOf(slot) + 1
          this.showEggPopup(eggNum, isCollected, slot)
        })
      })
    }

    bindPopupClose() {
      if (this.popup) {
        this.popup.querySelectorAll("[data-easter-popup-close]").forEach((el) => {
          el.addEventListener("click", () => this.closePopup(this.popup))
        })
        const cta = this.popup.querySelector("[data-popup-cta]")
        if (cta) {
          cta.addEventListener("click", async (e) => {
            e.stopPropagation()
            const variantId = cta.getAttribute("data-add-variant")
            const claimTier = cta.getAttribute("data-claim-tier")
            const copyDiscount = cta.getAttribute("data-copy-discount")

            if (copyDiscount) {
              navigator.clipboard.writeText(copyDiscount).then(() => {
                const original = cta.textContent
                cta.textContent = "Copied!"
                setTimeout(() => {
                  cta.textContent = original
                }, 2000)
              })
            } else if (variantId) {
              const originalText = cta.textContent
              cta.textContent = "Adding..."
              cta.style.pointerEvents = "none"
              try {
                await fetch("/cart/add.js", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
                })
                cta.textContent = "Already added"
                cta.className = "button button--sold-out easter-hunt--popup-cta"
                cta.removeAttribute("data-add-variant")
              } catch (err) {
                cta.textContent = originalText
                cta.style.pointerEvents = ""
              }
            } else if (claimTier) {
              cta.textContent = "Claiming..."
              cta.style.pointerEvents = "none"
              const result = await this.claimReward(parseInt(claimTier, 10))
              if (result && result.success) {
                cta.removeAttribute("data-claim-tier")
                this.updateRewardCards()

                // Show store credit amount in a styled box
                if (result.reward && result.reward.type === "store_credit" && result.reward.value) {
                  const titleEl = this.popup.querySelector("[data-popup-title]")
                  const textEl = this.popup.querySelector("[data-popup-text]")
                  const rewardSection = this.popup.querySelector("[data-popup-reward]")
                  if (titleEl) titleEl.textContent = this.titles.creditClaimed
                  if (textEl) textEl.textContent = "You've been awarded:"
                  if (rewardSection) {
                    rewardSection.style.display = ""
                    rewardSection.innerHTML = `
                      <div class="easter-hunt--discount-code">
                        <span class="easter-hunt--discount-code-value">${result.reward.title}</span>
                      </div>`
                  }
                  cta.textContent = "Claimed"
                  cta.className = "button button--sold-out easter-hunt--popup-cta"
                } else {
                  cta.textContent = "Claimed!"
                }
              } else if (result && result.error === "already_claimed") {
                cta.textContent = "Already claimed"
                cta.className = "button button--sold-out easter-hunt--popup-cta"
                cta.removeAttribute("data-claim-tier")
              } else {
                cta.textContent = "Claim store credit"
                cta.style.pointerEvents = ""
              }
            } else {
              this.closePopup(this.popup)
            }
          })
        }
      }
    }

    getNextTier(count) {
      for (const tier of this.tiers) {
        if (count < tier) return tier
      }
      return null
    }

    async showEggPopup(eggNum, isCollected, slotEl) {
      if (!this.popup) return

      const count = this.collectedCount
      const isTierUnlocked = this.rewards[count] && isCollected
      const nextTier = this.getNextTier(count)
      const pct = Math.round((count / this.totalEggs) * 100)

      const icon = this.popup.querySelector("[data-popup-icon]")
      if (icon && slotEl) {
        const foundImg = slotEl.getAttribute("data-found-image")
        if (foundImg) {
          icon.innerHTML = `<img src="${foundImg}" alt="Egg #${eggNum}" style="width:100%;height:auto;object-fit:contain;">`
        }
      }

      const badge = this.popup.querySelector("[data-popup-badge]")
      const title = this.popup.querySelector("[data-popup-title]")
      const text = this.popup.querySelector("[data-popup-text]")
      const progressSection = this.popup.querySelector("[data-popup-progress]")
      const progressCount = this.popup.querySelector("[data-popup-progress-count]")
      const progressPct = this.popup.querySelector("[data-popup-progress-pct]")
      const progressFill = this.popup.querySelector("[data-popup-progress-fill]")
      const nextSection = this.popup.querySelector("[data-popup-next]")
      const nextTitle = this.popup.querySelector("[data-popup-next-title]")
      const nextEggs = this.popup.querySelector("[data-popup-next-eggs]")
      const rewardSection = this.popup.querySelector("[data-popup-reward]")
      const rewardTitle = this.popup.querySelector("[data-popup-reward-title]")
      const rewardDesc = this.popup.querySelector("[data-popup-reward-desc]")
      const rewardNext = this.popup.querySelector("[data-popup-reward-next]")
      const cta = this.popup.querySelector("[data-popup-cta]")

      if (isTierUnlocked) {
        const reward = this.rewards[count]
        const tierNum = this.eggCountToTierNum(count)
        if (badge) {
          badge.textContent = "TIER UNLOCKED"
          badge.classList.add("easter-hunt--popup-badge--reward")
        }
        if (title) title.textContent = this.formatTitle(this.titles.unlocked, { reward: reward.popupTitle || reward.title })
        if (text)
          text.textContent = reward.desc
            ? `You've found ${count} eggs — ${reward.desc.charAt(0).toLowerCase() + reward.desc.slice(1)}`
            : `You've found ${count} eggs — you've unlocked a ${reward.title.toLowerCase()}.`
        if (progressSection) progressSection.style.display = "none"
        if (nextSection) nextSection.style.display = "none"
        if (rewardSection) {
          rewardSection.style.display = ""
          if (rewardTitle) rewardTitle.textContent = reward.title
          if (rewardDesc)
            rewardDesc.textContent = reward.desc || "Choose any product from our full range"
          if (rewardNext) rewardNext.style.display = "none"
        }
        if (cta) {
          const card = document.querySelector(`[data-reward-tier="${count}"]`)
          const isClaimed = card && card.classList.contains("claimed")
          const variantId = card ? card.getAttribute("data-reward-variant") : null
          cta.removeAttribute("data-add-variant")
          cta.removeAttribute("data-claim-tier")

          if (isClaimed) {
            cta.textContent = "Claimed"
            cta.className = "button button--sold-out easter-hunt--popup-cta"
            cta.style.pointerEvents = "none"
          } else if (variantId) {
            const inCart = await this.isVariantInCart(variantId)
            if (inCart) {
              cta.textContent = "Already in cart"
              cta.className = "button button--sold-out easter-hunt--popup-cta"
              cta.style.pointerEvents = "none"
            } else {
              cta.textContent = reward.cta || "Add to cart"
              cta.className = "button button--blue-fill easter-hunt--popup-cta"
              cta.style.pointerEvents = ""
              cta.setAttribute("data-add-variant", variantId)
            }
          } else {
            cta.textContent = reward.cta || "Claim reward"
            cta.className = "button button--blue-fill easter-hunt--popup-cta"
            cta.style.pointerEvents = ""
            cta.setAttribute("data-claim-tier", String(tierNum))
          }
        }
      } else if (isCollected) {
        if (badge) {
          badge.textContent = `EGG #${eggNum} FOUND!`
          badge.classList.remove("easter-hunt--popup-badge--reward")
        }
        if (count === 1) {
          if (title) title.textContent = this.titles.first
          if (text)
            text.textContent =
              "Keep exploring the site — more eggs are hidden on product pages, collection pages, and the blog."
        } else {
          if (title) title.textContent = this.formatTitle(this.titles.progress, { count: count })
          if (text)
            text.textContent =
              "Nice find! Keep browsing the site to discover more hidden eggs and unlock rewards."
        }
        if (progressCount) progressCount.textContent = `${count} / ${this.totalEggs}`
        if (progressPct) progressPct.textContent = `${pct}% complete`
        if (progressFill) progressFill.style.width = `${pct}%`
        if (progressSection) progressSection.style.display = ""
        if (nextTier && nextSection) {
          nextSection.style.display = ""
          const eggsToGo = nextTier - count
          if (nextTitle) nextTitle.textContent = this.rewards[nextTier].title
          if (nextEggs)
            nextEggs.textContent = `${eggsToGo} more egg${eggsToGo > 1 ? "s" : ""} to go`
        } else if (nextSection) {
          nextSection.style.display = "none"
        }
        if (rewardSection) rewardSection.style.display = "none"
        if (cta) {
          cta.textContent = "Keep hunting"
          cta.className = "button button--blue-fill easter-hunt--popup-cta"
          cta.style.pointerEvents = ""
          cta.removeAttribute("data-claim-tier")
        }
      } else {
        if (badge) {
          badge.textContent = `EGG #${eggNum}`
          badge.classList.remove("easter-hunt--popup-badge--reward")
        }
        if (title) title.textContent = this.titles.notFound
        if (text)
          text.textContent =
            "This egg is still hidden somewhere on the site. Keep browsing to find it!"
        if (progressCount) progressCount.textContent = `${count} / ${this.totalEggs}`
        if (progressPct) progressPct.textContent = `${pct}% complete`
        if (progressFill) progressFill.style.width = `${pct}%`
        if (progressSection) progressSection.style.display = ""
        if (nextTier && nextSection) {
          nextSection.style.display = ""
          const eggsToGo = nextTier - count
          if (nextTitle) nextTitle.textContent = this.rewards[nextTier].title
          if (nextEggs)
            nextEggs.textContent = `${eggsToGo} more egg${eggsToGo > 1 ? "s" : ""} to go`
        } else if (nextSection) {
          nextSection.style.display = "none"
        }
        if (rewardSection) rewardSection.style.display = "none"
        if (cta) {
          cta.textContent = "Keep hunting"
          cta.className = "button button--blue-fill easter-hunt--popup-cta"
          cta.style.pointerEvents = ""
          cta.removeAttribute("data-claim-tier")
        }
      }

      this.popup.style.display = "flex"
      requestAnimationFrame(() => {
        this.popup.classList.add("active")
        document.body.classList.add("no-scroll")
      })
    }

    async collectEgg(e, eggEl) {
      const isLoggedIn = eggEl.hasAttribute("data-logged-in")

      if (!isLoggedIn) {
        this.showLoginPopup()
        return
      }

      if (eggEl.hasAttribute("data-collected") || eggEl.classList.contains("easter-egg--loading")) {
        return
      }

      const eggId = eggEl.getAttribute("data-egg-id")
      eggEl.classList.add("easter-egg--loading")

      // Show popup immediately in loading state
      const pendingCount = this.collectedCount + 1
      this.showCollectingPopup(pendingCount)

      const result = await this.syncToApp(eggId)

      eggEl.classList.remove("easter-egg--loading")

      if (!result || !result.success) {
        console.warn("Easter Hunt: egg collection failed", result)
        this.closePopup(this.popup)
        return
      }

      // Server confirmed — update everything
      this.collectedCount++
      eggEl.setAttribute("data-collected", this.collectedCount)
      this.animateCollection(eggEl)
      this.updateCounter()
      this.updateNextSlot()
      this.updateRewardCards()

      // Auto-claim tiers when unlocked (based on egg count reaching a tier threshold)
      const count = this.collectedCount
      const tierIndex = this.tiers.indexOf(count)
      if (tierIndex !== -1) {
        const claimResult = await this.claimReward(tierIndex + 1)
        this.showConfirmedPopup(count, result, claimResult)
      } else {
        this.showConfirmedPopup(count, result, null)
      }
    }

    showCollectingPopup(pendingCount) {
      if (!this.popup) return

      const badge = this.popup.querySelector("[data-popup-badge]")
      const title = this.popup.querySelector("[data-popup-title]")
      const text = this.popup.querySelector("[data-popup-text]")
      const progressSection = this.popup.querySelector("[data-popup-progress]")
      const nextSection = this.popup.querySelector("[data-popup-next]")
      const rewardSection = this.popup.querySelector("[data-popup-reward]")
      const cta = this.popup.querySelector("[data-popup-cta]")

      if (badge) {
        badge.textContent = "COLLECTING..."
        badge.classList.remove("easter-hunt--popup-badge--reward")
      }
      if (title) title.textContent = this.formatTitle(this.titles.progress, { count: pendingCount })
      if (text) text.textContent = "Verifying your egg..."
      if (progressSection) progressSection.style.display = "none"
      if (nextSection) nextSection.style.display = "none"
      if (rewardSection) rewardSection.style.display = "none"
      if (cta) {
        cta.innerHTML = '<span class="easter-hunt--btn-loader"></span>'
        cta.className = "button button--blue-fill easter-hunt--popup-cta easter-hunt--popup-cta--loading"
        cta.style.pointerEvents = "none"
        cta.removeAttribute("data-claim-tier")
        cta.removeAttribute("data-add-variant")
        cta.removeAttribute("data-copy-discount")
      }

      this.popup.style.display = "flex"
      requestAnimationFrame(() => {
        this.popup.classList.add("active")
        document.body.classList.add("no-scroll")
      })
    }

    async showConfirmedPopup(count, result, claimResult) {
      if (!this.popup) return

      const isTierUnlocked = !!this.rewards[count]
      const nextTier = this.getNextTier(count)
      const pct = Math.round((count / this.totalEggs) * 100)

      const badge = this.popup.querySelector("[data-popup-badge]")
      const title = this.popup.querySelector("[data-popup-title]")
      const text = this.popup.querySelector("[data-popup-text]")
      const progressSection = this.popup.querySelector("[data-popup-progress]")
      const progressCount = this.popup.querySelector("[data-popup-progress-count]")
      const progressPct = this.popup.querySelector("[data-popup-progress-pct]")
      const progressFill = this.popup.querySelector("[data-popup-progress-fill]")
      const nextSection = this.popup.querySelector("[data-popup-next]")
      const nextTitle = this.popup.querySelector("[data-popup-next-title]")
      const nextEggs = this.popup.querySelector("[data-popup-next-eggs]")
      const rewardSection = this.popup.querySelector("[data-popup-reward]")
      const rewardTitle = this.popup.querySelector("[data-popup-reward-title]")
      const rewardDesc = this.popup.querySelector("[data-popup-reward-desc]")
      const cta = this.popup.querySelector("[data-popup-cta]")

      if (badge) {
        badge.textContent = "COLLECTED!"
        badge.classList.remove("easter-hunt--popup-badge--reward")
      }

      if (isTierUnlocked) {
        const reward = this.rewards[count]
        const card = document.querySelector(`[data-reward-tier="${count}"]`)
        const discountCode = (claimResult && claimResult.reward && claimResult.reward.discount_code) || (card ? card.getAttribute("data-discount-code") : null)
        const variantId = reward.variantId || (card ? card.getAttribute("data-reward-variant") : null)

        if (title) title.textContent = this.formatTitle(this.titles.unlocked, { reward: reward.popupTitle || reward.title })
        if (progressSection) progressSection.style.display = "none"
        if (nextSection) nextSection.style.display = "none"
        if (rewardSection) rewardSection.style.display = "none"

        if (cta) {
          cta.removeAttribute("data-add-variant")
          cta.removeAttribute("data-claim-tier")
          cta.removeAttribute("data-copy-discount")
          cta.style.pointerEvents = ""
          cta.className = "button button--blue-fill easter-hunt--popup-cta"
        }

        // Tier 1: Discount code
        if (reward.type === "discount") {
          if (discountCode) {
            if (text) text.textContent = `You've found ${count} eggs — your discount code is:`
            if (rewardSection) {
              rewardSection.style.display = ""
              rewardSection.innerHTML = `
                <div class="easter-hunt--discount-code">
                  <span class="easter-hunt--discount-code-value">${discountCode}</span>
                </div>`
            }
            if (cta) {
              cta.textContent = "Copy discount code"
              cta.setAttribute("data-copy-discount", discountCode)
            }
          } else {
            if (text) text.textContent = `You've found ${count} eggs — claim your reward!`
            if (cta) {
              cta.textContent = "Claim Reward"
              cta.setAttribute("data-claim-tier", "1")
            }
          }

        // Tier 2: Free product — add to cart
        } else if (reward.type === "product") {
          if (text) text.textContent = `You've found ${count} eggs — you've unlocked a ${reward.title.toLowerCase()}!`
          if (variantId) {
            const inCart = await this.isVariantInCart(variantId)
            if (cta) {
              if (inCart) {
                cta.textContent = "Already added"
                cta.className = "button button--sold-out easter-hunt--popup-cta"
                cta.style.pointerEvents = "none"
              } else {
                cta.textContent = "Add to cart"
                cta.setAttribute("data-add-variant", variantId)
              }
            }
          } else {
            if (cta) cta.textContent = "Keep hunting"
          }

        // Tier 3: Store credit — auto-claimed
        } else if (reward.type === "credit") {
          const creditValue = claimResult && claimResult.reward && claimResult.reward.title
          if (creditValue) {
            if (title) title.textContent = this.titles.creditClaimed
            if (text) text.textContent = `You've found all ${this.totalEggs} eggs! You've been awarded:`
            if (rewardSection) {
              rewardSection.style.display = ""
              rewardSection.innerHTML = `
                <div class="easter-hunt--discount-code">
                  <span class="easter-hunt--discount-code-value">${creditValue}</span>
                </div>`
            }
            if (cta) {
              cta.textContent = "Claimed"
              cta.className = "button button--sold-out easter-hunt--popup-cta"
              cta.style.pointerEvents = "none"
            }
          } else {
            if (text) text.textContent = `You've found all ${count} eggs! Claim your store credit.`
            if (cta) {
              cta.textContent = "Claim store credit"
              cta.setAttribute("data-claim-tier", "3")
            }
          }
        }
      } else {
        if (count === 1) {
          if (title) title.textContent = this.titles.first
          if (text) text.textContent = "Keep exploring the site — more eggs are hidden on product pages, collection pages, and the blog."
        } else {
          if (title) title.textContent = this.formatTitle(this.titles.progress, { count: count })
          if (text) text.textContent = "Nice find! Keep browsing the site to discover more hidden eggs and unlock rewards."
        }
        if (progressCount) progressCount.textContent = `${count} / ${this.totalEggs}`
        if (progressPct) progressPct.textContent = `${pct}% complete`
        if (progressFill) progressFill.style.width = `${pct}%`
        if (progressSection) progressSection.style.display = ""
        if (nextTier && nextSection) {
          nextSection.style.display = ""
          const eggsToGo = nextTier - count
          if (nextTitle) nextTitle.textContent = this.rewards[nextTier].title
          if (nextEggs) nextEggs.textContent = `${eggsToGo} more egg${eggsToGo > 1 ? "s" : ""} to go`
        } else if (nextSection) {
          nextSection.style.display = "none"
        }
        if (rewardSection) rewardSection.style.display = "none"
        if (cta) {
          cta.textContent = "Keep hunting"
          cta.className = "button button--blue-fill easter-hunt--popup-cta"
          cta.style.pointerEvents = ""
          cta.removeAttribute("data-claim-tier")
          cta.removeAttribute("data-add-variant")
        }
      }
    }

    animateCollection(eggEl) {
      eggEl.classList.add("easter-egg-banner--collecting")
      this.createSparkles(eggEl)
      setTimeout(() => {
        eggEl.classList.add("easter-egg-banner--collected")
        setTimeout(() => {
          eggEl.style.display = "none"
        }, 500)
      }, 800)
    }

    createSparkles(eggEl) {
      const rect = eggEl.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2
      const colors = ["#FFD700", "#FF6B9D", "#87CEEB", "#98FB98", "#DDA0DD"]
      for (let i = 0; i < 12; i++) {
        const sparkle = document.createElement("div")
        sparkle.className = "easter-egg--sparkle"
        sparkle.style.left = centerX + "px"
        sparkle.style.top = centerY + "px"
        sparkle.style.backgroundColor = colors[i % colors.length]
        const angle = (i / 12) * 360
        const distance = 40 + Math.random() * 40
        sparkle.style.setProperty("--angle", angle + "deg")
        sparkle.style.setProperty("--distance", distance + "px")
        document.body.appendChild(sparkle)
        setTimeout(() => sparkle.remove(), 1000)
      }
    }

    updateCounter() {
      const count = this.collectedCount

      if (this.counter) {
        this.counter.textContent = count
        this.counter.classList.add("easter-hunt--counter-bump")
        setTimeout(() => this.counter.classList.remove("easter-hunt--counter-bump"), 400)
      }
      if (this.countDisplay) {
        this.countDisplay.textContent = count + " / " + this.totalEggs
      }

      const remainingEl = document.querySelector("[data-egg-remaining]")
      if (remainingEl) {
        remainingEl.textContent = this.totalEggs - count
      }

      const pct = Math.round((count / this.totalEggs) * 100)
      const progressFill = document.querySelector(".easter-hunt--progress-fill")
      if (progressFill) {
        progressFill.style.width = pct + "%"
      }

      document.querySelectorAll(".easter-hunt--progress-marker").forEach((marker) => {
        const threshold = parseInt(marker.textContent, 10)
        if (count >= threshold) {
          marker.classList.add("reached")
        } else {
          marker.classList.remove("reached")
        }
      })
    }

    updateNextSlot() {
      const slots = document.querySelectorAll(".easter-hunt--egg-slot:not(.collected)")
      if (slots.length === 0) return
      const slot = slots[0]
      slot.classList.add("collected")
      const wrappedImg = slot.querySelector(".easter-hunt--egg-wrapped")
      const foundImg = slot.querySelector(".easter-hunt--egg-found")
      if (wrappedImg) wrappedImg.classList.add("hidden")
      if (foundImg) {
        foundImg.classList.remove("hidden")
        foundImg.classList.add("easter-hunt--egg-reveal")
      }
    }

    updateRewardCards() {
      const count = this.collectedCount
      document.querySelectorAll(".easter-hunt--reward-card").forEach((card) => {
        const tier = parseInt(card.getAttribute("data-reward-tier"), 10)
        if (!tier || count < tier) return

        card.classList.add("unlocked")
        const status = card.querySelector(".easter-hunt--reward-status")
        const action = card.querySelector(".easter-hunt--reward-action")

        const locked = card.querySelector(".easter-hunt--reward-locked")
        if (locked) locked.style.display = "none"

        if (card.classList.contains("claimed")) {
          if (status) {
            status.textContent = "Claimed"
            status.className = "easter-hunt--reward-status easter-hunt--reward-status--claimed"
          }
          if (action) {
            action.innerHTML = '<span class="button button--sold-out">Claimed</span>'
          }
        } else {
          if (status) {
            status.textContent = "Unlocked"
            status.className = "easter-hunt--reward-status easter-hunt--reward-status--unlocked"
          }
          if (action) {
            action.innerHTML = '<span class="button button--reward-claimed">Claim Reward</span>'
          }
        }
      })
    }

    async claimReward(tier) {
      try {
        const response = await fetch(this.claimUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ action: "claim", tier: tier }),
        })

        const data = await response.json().catch(() => null)

        if (!response.ok) {
          console.warn("Easter Hunt: claim failed", response.status, data)
          return data || { success: false }
        }

        console.log("Easter Hunt: reward claimed", data)
        return data
      } catch (err) {
        console.warn("Easter Hunt: claim error", err)
        return null
      }
    }

    closePopup(popup) {
      popup.classList.remove("active")
      document.body.classList.remove("no-scroll")
      setTimeout(() => {
        popup.style.display = "none"
      }, 300)
    }

    async syncToApp(eggId) {
      try {
        const response = await fetch(this.appProxyUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ egg_id: eggId }),
        })

        const data = await response.json().catch(() => null)

        if (!response.ok) {
          console.warn("Easter Hunt: sync failed", response.status, data)
          return data || { success: false }
        }

        return data
      } catch (err) {
        console.warn("Easter Hunt: App sync error", err)
        return null
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => new EasterEggHunt())
  } else {
    new EasterEggHunt()
  }
})()
